import React from 'react';
import BottomSheet from '../components/BottomSheet/BottomSheet';
import Typography from '../components/Text/Typography';
import Button from '../components/Button/Button';
import './PrivacyBottomSheet.css';

interface PrivacyBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyBottomSheet: React.FC<PrivacyBottomSheetProps> = ({ isOpen, onClose }) => {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Privacy Policy"
      height="80vh"
      className="privacy-bottom-sheet"
    >
      <div className="privacy-content">
        <Typography variant="body" className="privacy-text">
          <strong>🔒 Dew – Privacy Policy</strong>
          <br /><br />
          
          <strong>Effective Date: September 16, 2025</strong>
          <br /><br />
          
          Dew ("we," "our," or "us") respects your privacy. This Privacy Policy explains what data we collect, how we use it, and your rights.
          <br /><br />
          
          <strong>1. Information We Collect</strong>
          <br />
          Account Information: Email, login details.
          <br />
          Health & Wellness Data: Skin type, concerns, allergies, skincare routines.
          <br />
          User Content: Custom routines, notes, or feedback you share.
          <br />
          Technical Data: Device/browser info; may include cookies or analytics tools.
          <br /><br />
          
          <strong>2. How We Use Your Information</strong>
          <br />
          To provide and personalize your routines.
          <br />
          To improve Dew's algorithm and features.
          <br />
          To communicate updates, feedback requests, and service changes.
          <br />
          To comply with legal obligations.
          <br /><br />
          
          <strong>3. Sharing of Information</strong>
          <br />
          We do not sell or rent your personal information.
          <br />
          We may share data with:
          <br />
          Service providers (e.g., hosting, authentication) that help operate Dew.
          <br />
          Legal authorities if required by law.
          <br /><br />
          
          <strong>4. Sensitive Health Data</strong>
          <br />
          Because Dew collects skincare-related information, including skin conditions and allergies, you acknowledge and consent to us processing this sensitive data for the purpose of tailoring your routines.
          <br /><br />
          
          <strong>5. Cookies & Analytics</strong>
          <br />
          Dew may use cookies or analytics to understand how users engage with the app. You can disable cookies in your browser settings.
          <br /><br />
          
          <strong>6. Data Retention</strong>
          <br />
          We keep your data as long as you maintain an account.
          <br />
          You may request deletion of your account and data at any time.
          <br /><br />
          
          <strong>7. Children's Privacy</strong>
          <br />
          Users under 18 must have parental/guardian consent.
          <br />
          If we discover data collected from a child without consent, we will delete it.
          <br /><br />
          
          <strong>8. Your Rights</strong>
          <br />
          Depending on your location, you may have rights to:
          <br />
          Access or request a copy of your data.
          <br />
          Request correction or deletion.
          <br />
          Withdraw consent for processing sensitive data.
          <br /><br />
          
          <strong>9. Security</strong>
          <br />
          We use reasonable measures to protect your information but cannot guarantee absolute security.
          <br /><br />
          
          <strong>10. Changes to Policy</strong>
          <br />
          We may update this Privacy Policy. We will notify you of material changes by updating the "Effective Date."
          <br /><br />
          
          <strong>11. Contact</strong>
          <br />
          If you have questions, contact us at: dew.don.lee@gmail.com
        </Typography>
      </div>

      <div className="privacy-footer">
        <Button
          variant="primary"
          onClick={onClose}
          className="close-button"
        >
          Close
        </Button>
      </div>
    </BottomSheet>
  );
};

export default PrivacyBottomSheet;
